import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';
import { Quote } from 'lucide-react';

export function FounderSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section 
      id="founder"
      className="relative py-24 md:py-32 overflow-hidden"
      data-testid="founder-section"
    >
      {/* Decorative — restrained signal accent */}
      <div className="absolute top-1/2 left-0 w-96 h-96 bg-signal-glow rounded-full blur-[140px] -translate-y-1/2 opacity-50" />
      
      <div ref={ref} className="relative max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          {/* Left - Image */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
            className="lg:col-span-5"
          >
            <div className="founder-image relative aspect-[3/4] max-w-md mx-auto lg:mx-0">
              <img
                src="/founder.jpg?v=4"
                alt="Chukwuemeka Nkemakolam - Founder"
                className="w-full h-full object-cover"
              />
            </div>
          </motion.div>
          
          {/* Right - Content */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
            className="lg:col-span-7"
          >
            <p className="eyebrow section-eyebrow-line mb-6">
              Founder's Message
            </p>
            
            <div className="relative">
              <Quote className="absolute -top-4 -left-4 w-12 h-12 text-stark/[0.08]" />
              
              <blockquote className="text-xl md:text-2xl lg:text-3xl font-heading font-light text-stark leading-relaxed mb-8 tracking-tight">
                ServeNetics was born from a vision to become a{' '}
                <span className="text-gradient font-medium">force for global good</span>{' '}
                through technology.
              </blockquote>
              
              <p className="text-stark-2 leading-relaxed mb-6">
                With over two decades of experience across business, technology, and 
                human development, I believe that true success lies in lifting others 
                while building the future.
              </p>
              
              <p className="text-stark-2 leading-relaxed mb-8">
                This is more than a company — it is a movement to prove that with{' '}
                <span className="text-stark">hard work, discipline, honesty, and faith</span>, 
                transformation is inevitable.
              </p>
              
              <div className="flex items-center gap-4">
                <div className="w-16 h-px bg-signal" />
                <div>
                  <p className="font-heading font-semibold text-stark text-lg">
                    Chukwuemeka Nkemakolam
                  </p>
                  <p className="text-sm text-stark-2 font-mono">
                    Founder, ServeNetics
                  </p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}

export default FounderSection;
